import { ReactNode, useEffect, useMemo } from 'react'
import { deleteAuthToken } from 'library/FetchHelper'
import useAuth from 'hooks/useAuth'
import useToast from 'hooks/useToast'
import { useSelector } from 'react-redux'
import { BLOCKED_ADDRESSES } from './config/constants'
import useActiveWeb3React from './hooks/useActiveWeb3React'
import ListsUpdater from './state/lists/updater'
import MulticallUpdater from './state/multicall/updater'
import TransactionUpdater from './state/transactions/updater'

export function Updaters() {
  return (
    <>
      <ListsUpdater />
      <TransactionUpdater />
      <MulticallUpdater />
    </>
  )
}

export function Blocklist({ children }: { children: ReactNode }) {
  const { account } = useActiveWeb3React()
  const { logout } = useAuth()
  const { toastSuccess }: any = useToast()
  const { isLogin } = useSelector((state: any) => state.auth)

  useEffect(() => {
    if (isLogin) {
      logout()
      deleteAuthToken()
      toastSuccess('You changed your account, please login again!')
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [account, logout, toastSuccess])

  const blocked: boolean = useMemo(() => Boolean(account && BLOCKED_ADDRESSES.indexOf(account) !== -1), [account])
  if (blocked) {
    return <div>Blocked address</div>
  }
  return <>{children}</>
}
